import axios from "axios";

export function getRemoteStorageProxy(url, namespace, apikey) {
  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  if (typeof apikey !== "undefined") {
    headers["X-Api-Key"] = apikey;
  }
  let px = axios.create({
    baseURL: url,
    withCredentials: false,
    headers,
    timeout: 60000
  });

  return {
    px,
    namespace,
    increment(key) {
      let payload = { key, namespace: this.namespace };
      return this.px.post("increment", payload).then(r => {
        if (!r.data.error) return r.data.value;
        else throw new Error(r.info);
      });
    },
    set(key, value) {
      let payload = { key, value, namespace: this.namespace };
      return this.px.post("set", payload).then(r => {
        if (!r.data.error) return r.data.value;
        else throw new Error(r.info);
      });
    },
    get(key) {
      let payload = { key, namespace: this.namespace };
      return this.px.post("get", payload).then(r => {
        if (!r.data.error) return r.data.value;
        else throw new Error(r.info);
      });
    }
  };
}
